import type { SubRouteConfig } from "@neu/libui";

import { PlanSnapshot } from "./PlanSnapshot";

export const planSubNavItems = [
	{
		path: "snapshot",
		label: "Snapshot",
		entity: "",
		listComponent: PlanSnapshot,
	},
	{
		path: "claim-dispense",
		label: "Claim Dispense",
		entity: "plan_claim_dispense",
		componentProps: {
			showAddButton: false,
			showEditButton: false,
		},
	},
	{ path: "invoices", label: "Plan Invoices", entity: "plan_invoice" },
	{ path: "group", label: "Plan Group", entity: "plan_group" },
	{ path: "attachment", label: "File Attachment", entity: "plan_attachment" },
	{
		path: "formulary",
		label: "Plan Formulary",
		entity: "formulary_drugs_plan",
	},
	{
		path: "group-formulary",
		label: "Plan Group Formulary",
		entity: "formulary_drugs_plan_group",
	},
] satisfies Array<SubRouteConfig & { label: string }>;
